import PropTypes from 'prop-types'
import { Notice } from '@pretamanger/component-library'
import { useRouter } from 'next/router'
import { translate } from '#src/common/components/translation'
import { NoticeContainer } from './styles'

const Allergens = ({ allergens }) => {
  const { locale } = useRouter()
  const allergensLabels = allergens.map(allergen => allergen.label).join(', ')
  const getAllergens = translate('product.allergens.text', locale, {
    allergens: allergensLabels
  })?.value

  return (
    allergens.length > 0 && (
      <NoticeContainer data-testid='allergens-container'>
        <Notice title={getAllergens} variant='info' />
      </NoticeContainer>
    )
  )
}

Allergens.propTypes = {
  allergens: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string
    })
  )
}

Allergens.defaultProps = {
  allergens: []
}

export default Allergens
